import { loadYouTubeAPI } from '../utils';

export default (youtubeVideoId) => ({
  open: false,
  player: null,
  playerElement: null,
  youtubeVideoId: '',
  onReady: false,
  onYouTubePlayerAPIReady: false,
  init() {
    loadYouTubeAPI();

    this.youtubeVideoId = youtubeVideoId;
    this.playerElement = this.$refs.ytplayer;

    window.onYouTubePlayerAPIReady = () => {
      this.onYouTubePlayerAPIReady = true;
    };
  },
  handleClick() {
    if (!this.onYouTubePlayerAPIReady) {
      return;
    }
    this.open = true;

    this.player = new YT.Player(this.playerElement, {
      height: 'auto',
      width: '100%',
      videoId: this.youtubeVideoId,
      events: {
        onReady: (event) => {
          const iframe = event.target.getIframe();
          iframe.classList.add('w-full', 'aspect-video');

          this.onReady = true;
          this.player.playVideo();
        }
      }
    });
  }
});
